<template>
  <div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">CPU Utilization:</span>
      <span class="text-sm">{{ oltInfo.cpu_utilization }}%</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Device SN:</span>
      <span class="text-sm">{{ oltInfo.device_sn }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Device Type:</span>
      <span class="text-sm">{{ oltInfo.device_type }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Free Memory:</span>
      <span class="text-sm">{{ oltInfo.free_memory }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Hardware Version:</span>
      <span class="text-sm">{{ oltInfo.hardware_version }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Host Name:</span>
      <span class="text-sm">{{ oltInfo.host_name }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Inband MAC:</span>
      <span class="text-sm">{{ oltInfo.inband_mac }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Outband MAC:</span>
      <span class="text-sm">{{ oltInfo.outband_mac }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Running Time:</span>
      <span class="text-sm">{{ oltInfo.running_time }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Software Version:</span>
      <span class="text-sm">{{ oltInfo.software_version }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Temperature:</span>
      <span class="text-sm">{{ oltInfo.temperature_c }}°C</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Total Memory:</span>
      <span class="text-sm">{{ oltInfo.total_memory }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Vendor:</span>
      <span class="text-sm">{{ oltInfo.vendor_name }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CdataOltInfo',
  props: {
    oltInfo: {
      type: Object,
      required: true
    }
  }
}
</script>